export default {
  task_statistics: [],
  users: {
    results: [],
  },
  projects: {
    results: [],
  },
  steps: [],
  tasks: [],
  all_tasks: {
    results: [],
  },
  sprints: {
    results: [],
  },
  active_sprint: {},
  clients: {
    results: [],
  },

  comments: {
    results: [],
  },

  task: {},
  sp_chart_data_by_devs: {
  },
  task_statistic_list: [],
  task_manager_list: {
    results: [],
  },
  task_gantt: [],

  priorities_list: {
    results: [],
  },
  calendar_task_list: [],
  attachments: {
    results: [],
  },
}
